import React from 'react';
import {Heading, HStack, VStack, Progress, Spacer} from 'native-base';
import {DollarIcon} from '../icons';
import {ColorType} from 'native-base/lib/typescript/components/types';

interface Props {
  label: string;
  amount: string;
  value: number;
  color?: ColorType;
}

const Semaphore = (props: Props) => {
  const {label, amount, value, color} = props;

  return (
    <VStack flex={1}>
      <HStack>
        <Heading fontSize="14" color="#858597" flex={1.3}>
          {label}
        </Heading>
        <HStack flex={1}>
          <DollarIcon />
          <Spacer />
          <Heading
            fontSize="16"
            fontWeight={'extrabold'}
            color="#06355E"
            marginLeft={3}>
            {`${amount}`}
          </Heading>
        </HStack>
      </HStack>
      <Progress
        value={value}
        marginTop="3"
        size="3.5"
        width={'100%'}
        _filledTrack={{bg: color ?? 'blue.400'}}
      />
    </VStack>
  );
};

export default Semaphore;
